import React from 'react';
import { Link } from 'react-router-dom';
import { FaArrowLeft, FaSitemap } from 'react-icons/fa';
import { FaGraduationCap, FaUniversity, FaHome, FaInfoCircle, FaBook, FaEnvelope } from 'react-icons/fa';
import SEOMetadata from '../SEOMetadata/SEOMetadata';

const Sitemap = () => {
  const mainLinks = [
    { text: 'Home', href: '/home', icon: <FaHome /> },
    { text: 'PhD Openings', href: '/phd-vacancies/standard', icon: <FaGraduationCap /> },
    { text: 'Smart Picks', href: '/smart-picks', icon: <FaUniversity /> },
    { text: 'PhD Blogs', href: '/blogs', icon: <FaBook /> },
    { text: 'Contact', href: '/contact', icon: <FaEnvelope /> },
    { text: 'About Us', href: '/about', icon: <FaInfoCircle /> },
  ];

  const countryLinks = [
    { text: 'Belgium', href: '/phd-vacancies/standard/Belgium' },
    { text: 'Denmark', href: '/phd-vacancies/standard/Denmark' },
    { text: 'Finland', href: '/phd-vacancies/standard/Finland' },
    { text: 'France', href: '/phd-vacancies/standard/France' },
    { text: 'Germany', href: '/phd-vacancies/standard/Germany' },
    { text: 'Luxembourg', href: '/phd-vacancies/standard/Luxembourg' },
    { text: 'Netherlands', href: '/phd-vacancies/standard/Netherlands' },
    { text: 'Norway', href: '/phd-vacancies/standard/Norway' },
    { text: 'Sweden', href: '/phd-vacancies/standard/Sweden' },
    { text: 'Switzerland', href: '/phd-vacancies/standard/Switzerland' },
    { text: 'United Kingdom', href: '/phd-vacancies/standard/United-Kingdom' },
  ];

  const legalLinks = [
    { text: 'Privacy Policy', href: '/privacy-policy' },
    { text: 'Terms of Service', href: '/terms' },
    { text: 'Cookie Policy', href: '/cookies' },
    { text: 'Sitemap', href: '/sitemap' },
  ];

  return (
    <div className="min-h-screen bg-gradient-to-b from-[#FFEEED] to-white">
        <SEOMetadata 
        title="Sitemap | PhDScanner"
        description="Explore the complete structure of PhDScanner's website with our detailed sitemap."
        keywords="PhDScanner sitemap, website structure, navigation map, phd jobs, university jobs, jobs, jobs education technology,  research in education jobs"
        imageUrl="https://www.phdscanner.com/phdscanner_logo.webp"
        url="https://www.phdscanner.com/sitemap"
      />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        {/* Back Button */}
        <Link 
          to="/" 
          className="mb-8 inline-flex items-center text-[#DB4F40] hover:text-[#C64537] font-medium transition-colors"
        >
          <FaArrowLeft className="mr-2" />
          Back to Home
        </Link>

        {/* Hero Section */}
        <div className="text-center mb-16">
          <div className="bg-[#DB4F40]/10 rounded-full p-4 inline-block mb-6">
            <FaSitemap className="text-4xl text-[#DB4F40]" />
          </div>
          <h1 className="text-4xl font-extrabold text-[#1B222A] mb-4">
            Sitemap
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Explore all the pages and sections of PhDScanner.
          </p>
        </div>

        {/* Content Container */}
        <div className="bg-white rounded-2xl shadow-lg p-8 sm:p-12 border border-[#DB4F40]/20">
          {/* Main Navigation Section */}
          <section className="mb-12">
            <h2 className="text-3xl font-bold text-[#1B222A] mb-6">
              Main Navigation
            </h2>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {mainLinks.map((link, index) => (
                <Link
                  key={index}
                  to={link.href}
                  className="flex items-center p-4 hover:bg-[#FFEEED]/50 rounded-lg transition-colors"
                >
                  <span className="text-[#DB4F40] mr-3 text-xl">
                    {link.icon}
                  </span>
                  <span className="text-lg font-medium text-[#1B222A]">
                    {link.text}
                  </span>
                </Link>
              ))}
            </div>
          </section>

          {/* PhD Openings by Country Section */}
          <section className="mb-12">
            <h2 className="text-3xl font-bold text-[#1B222A] mb-6">
              PhD Openings by Country
            </h2>
            
            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4">
              {countryLinks.map((link, index) => (
                <Link
                  key={index}
                  to={link.href}
                  className="flex items-center p-3 hover:bg-[#FFEEED]/50 rounded-lg transition-colors"
                >
                  <span className="text-[#DB4F40] mr-2">
                    <FaGraduationCap />
                  </span>
                  <span className="text-[#1B222A]">
                    {link.text}
                  </span>
                </Link>
              ))}
            </div>
          </section>

          {/* Legal Pages Section */}
          <section>
            <h2 className="text-3xl font-bold text-[#1B222A] mb-6">
              Legal Pages
            </h2>
            
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4">
              {legalLinks.map((link, index) => (
                <Link
                  key={index}
                  to={link.href}
                  className="flex items-center justify-center p-4 hover:bg-[#FFEEED]/50 rounded-lg transition-colors border border-[#DB4F40]/20"
                >
                  <span className="text-[#1B222A] font-medium">
                    {link.text}
                  </span>
                </Link>
              ))}
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Sitemap;